// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"40ac4605","202":"cbb0db52","217":"8dffb332","223":"3e97457e","354":"ced45bc7","364":"271b01f1","422":"d4553934","983":"c9ff0e4e"}[chunkId] + ".chunk.js";
};